import findSize from '@components/Templates/utils/findSize';
import { Size } from '@components/Templates/utils/types';
import React from 'react';
import { MAX_HEIGHT, MAX_WIDTH } from './constants';
import DesignSetImage from './DesignSetImage';

type DesignSetSizeProps = {
  height: number;
  width: number;
  sizes: Size[];
  isRow?: boolean;
};

export function DesignSetSize({ sizes, height, width, isRow = false }: DesignSetSizeProps) {
  const size = findSize(sizes, width, height);
  const style = {
    width: !isRow ? '100%' : widthPercent(width),
    height: isRow ? '100%' : heightPercent(height),
  };

  return (
    <div className="relative box-border p-[4px] sm:p-[5px] md:p-[4px] lg:p-[5px]" style={style}>
      {size && <DesignSetImage hash={size.hash} name={size.name} width={size.width} height={size.height} />}
    </div>
  );
}

type LayoutRowProps = {
  children: React.ReactNode;
  height?: number;
};

export function LayoutRow({ children, height = MAX_HEIGHT }: LayoutRowProps) {
  const style = {
    height: heightPercent(height),
  };

  return (
    <div className="flex w-full flex-row" style={style}>
      {children}
    </div>
  );
}

type LayoutColProps = {
  children: React.ReactNode;
  width?: number;
};

export function LayoutCol({ children, width = MAX_WIDTH }: LayoutColProps) {
  const style = {
    width: widthPercent(width),
  };

  return (
    <div className="flex h-full flex-col" style={style}>
      {children}
    </div>
  );
}

function widthPercent(width: number): string {
  return `${(width / MAX_WIDTH) * 100}%`;
}

function heightPercent(height: number): string {
  return `${(height / MAX_HEIGHT) * 100}%`;
}
